import { RemoteDataStore } from '@move-frontend/utils';
import { action, makeObservable, observable } from 'mobx';
import type { CaptureContextSessionService } from '../../../shared/api/gateway/services/CaptureContextSessionService';
import type { ICaptureContextResponse } from '../../../shared/api/gateway/types/ICaptureContextResponse';

type RequestParams = Record<never, never>;

export class CaptureContextStore extends RemoteDataStore<
	RequestParams,
	ICaptureContextResponse
> {
	private _value: string | undefined = undefined;

	private _clientLibrary: string | undefined = undefined;

	private _clientLibraryIntegrity: string | undefined = undefined;

	constructor(private readonly service: CaptureContextSessionService) {
		super();

		makeObservable<
			CaptureContextStore,
			'handleResponse' | '_value' | '_clientLibrary' | '_clientLibraryIntegrity'
		>(this, {
			handleResponse: action,
			clear: action,
			_value: observable,
			_clientLibrary: observable,
			_clientLibraryIntegrity: observable,
		});
	}

	public load(params: RequestParams = {}) {
		return super.load(params);
	}

	protected performRequest(): Promise<ICaptureContextResponse> {
		return this.service.create('microform');
	}

	protected handleResponse(response: ICaptureContextResponse): void {
		this._value = response.jwt;
		this._clientLibrary = response.clientLibrary;
		this._clientLibraryIntegrity = response.clientLibraryIntegrity;
	}

	get value() {
		return this._value;
	}

	get clientLibrary() {
		return this._clientLibrary;
	}

	get clientLibraryIntegrity() {
		return this._clientLibraryIntegrity;
	}

	clear() {
		this._value = undefined;
		this._clientLibrary = undefined;
		this._clientLibraryIntegrity = undefined;
	}
}
